import Box from '@mui/material/Box';

/**
 * `text` with every case-insensitive occurrence of `query` in bold — the same comparison the API
 * searched with, so what is marked is what matched.
 */
export function Highlight({ text, query }: { text: string; query: string }) {
  const needle = query.trim().toLowerCase();
  if (!needle) return <>{text}</>;

  const parts: { text: string; hit: boolean }[] = [];
  const haystack = text.toLowerCase();
  let from = 0;
  for (let at = haystack.indexOf(needle); at !== -1; at = haystack.indexOf(needle, from)) {
    if (at > from) parts.push({ text: text.slice(from, at), hit: false });
    parts.push({ text: text.slice(at, at + needle.length), hit: true });
    from = at + needle.length;
  }
  if (from < text.length) parts.push({ text: text.slice(from), hit: false });

  return (
    <>
      {parts.map((part, index) =>
        part.hit ? (
          <Box
            key={index}
            component="mark"
            sx={{ bgcolor: 'warning.light', color: 'inherit', px: 0 }}
          >
            {part.text}
          </Box>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </>
  );
}
